import { Link } from "react-router-dom";
import { LogoStacked } from "../components/Logo";

export default function Footer({ content }) {
  return (
    <footer className="border-t border-white/10 bg-black" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
          <div>
            <LogoStacked className="h-20 w-auto" />
            <p className="mt-4 text-sm text-gray-500 max-w-xs leading-relaxed">
              {content.contact.service_area}
            </p>
          </div>
          <nav className="grid grid-cols-2 gap-x-14 gap-y-3 text-sm">
            {["Services", "Why Us", "About", "Pricing", "Contact"].map((l) => (
              <a key={l} href={`#${l.toLowerCase().replace(/\s/g, "-")}`} className="text-gray-400 hover:text-white transition-colors uppercase tracking-[0.15em] text-xs font-semibold">
                {l}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-14 border-t border-white/10 pt-8 space-y-3" data-testid="footer-disclaimers">
          <p className="text-xs text-gray-500 leading-relaxed max-w-4xl">
            Vehicle modifications, including ECU remapping, may affect your vehicle's compliance with applicable UK road traffic laws, emissions regulations and MOT requirements. It is the customer's responsibility to ensure their vehicle remains road legal.
          </p>
          <p className="text-xs text-gray-500 leading-relaxed max-w-4xl">
            You must inform your insurance provider of any modifications made to your vehicle. Failure to declare modifications may invalidate your insurance policy.
          </p>
          <p className="text-xs text-gray-500 leading-relaxed max-w-4xl">
            Results vary between vehicles. Any performance figures discussed are estimates based on typical results and are not guaranteed.
          </p>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-white/10 pt-6">
          <p className="text-xs text-gray-600">© {new Date().getFullYear()} TheMapLab. All rights reserved.</p>
          <p className="text-[10px] uppercase tracking-[0.3em] text-gray-700">Unlock Your Vehicle's Potential</p>
        </div>
      </div>
    </footer>
  );
}
